import { Analysis } from 'common-spectrum';
import { appendedParser } from 'ndim-parser';
import { appendUnits } from './utils';
export default class BaseB1505 {
    constructor(xLabel, yLabel, scale) {
        this.metaVarHeaders = [
            'Analysis.Setup.Vector.Graph.XAxis',
            'Analysis.Setup.Vector.Graph.YAxis',
            'Analysis.Setup.Vector.List.Datum',
            'Function.User',
        ];
        this.xLabel = xLabel;
        this.yLabel = yLabel;
        this.scale = scale;
    }
    parseMeta(meta) {
        if (!meta)
            return {};
        let ans = {};
        for (const key in meta) {
            ans[key] = meta[key]
                .split(',')
                .filter((val) => val !== '')
                .join(',');
        }
        // add default kind scale
        const { xLabel, yLabel, scale } = this;
        ans['default.xLabel'] = xLabel;
        ans['default.yLabel'] = yLabel;
        ans['default.scale'] = scale;
        return ans;
    }
    metaUnits(meta) {
        let knownUnits = {};
        for (const key of this.metaVarHeaders) {
            const keyName = `${key}.${"Name" /* name */}`;
            const keyUnits = `${key}.${"Units" /* units */}`;
            if (meta[keyName] && meta[keyUnits]) {
                const names = meta[keyName].split(',');
                const units = meta[keyUnits].split(',');
                for (let index = 0; index < names.length; index++) {
                    knownUnits[names[index]] = units[index];
                }
            }
        }
        return knownUnits;
    }
    parseText(text) {
        const series = appendedParser(text);
        let analyses = [];
        for (const { data, meta } of series) {
            const parsedMeta = this.parseMeta(meta);
            const knownUnits = this.metaUnits(meta);
            let analysis = new Analysis();
            analysis.pushSpectrum(appendUnits(data, knownUnits), {
                title: parsedMeta.Remarks ||
                    parsedMeta['TestRecord.Remarks'] ||
                    parsedMeta['Device ID'] ||
                    parsedMeta['Setup title'] ||
                    parsedMeta.SetupTitle,
                meta: parsedMeta,
            });
            analyses.push(analysis);
        }
        return analyses;
    }
}
//# sourceMappingURL=data:application/json;base64,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